import Vue from 'vue'
import Vuex from 'vuex'
import axiosInstance from "../services/api.js"
import VueSimpleAlert from "vue-simple-alert";


Vue.use(Vuex, VueSimpleAlert)
const self = Vue
const store = new Vuex.Store(
    {
        state: {
            access_token: localStorage.getItem('access_token') || '',
            userData: JSON.parse(localStorage.getItem('user_data',) || "{}"),
            dataTable: [],
            editDataRow: {},
            ServerUrl: "https://lead-mart.ru/api", 
            users: [],
            editUser: {},
            userRoles: [],
            tows: [],
            canUpdateTable: true,

            curSelectorOptions: {
              site: [],
              city: [],
              partner: [],
            },
        },
        actions: {

              POST_TABLE_FROM_API({commit}, dataJson) {
                  const data = dataJson.dataJson
                  const skip = dataJson.skip;
                  const limit = dataJson.limit;
                  return axiosInstance(store.state.ServerUrl + '/orders',
                      {
                          method: "POST",
                          data: data,
                          params: {skip, limit},
                          headers: {'Content-Type': 'application/json'}

                      }
                  ).then((response) => {
                      commit('SET_TABLE_TO_VUEX', response.data)
                  })
              },

              updateTableData({commit}, dataJson) {
                const data = dataJson.dataJson
                const skip = dataJson.skip;
                const limit = dataJson.limit;
                return axiosInstance(store.state.ServerUrl + '/orders',
                    {
                        method: "POST",
                        data: data,
                        params: {skip, limit},
                        headers: {'Content-Type': 'application/json'}

                    }
                ).then((response) => {
                    commit('updateTableData', response.data)
                });
            },

            setEditDataRow({commit}) {
                const data = JSON.parse(localStorage.getItem("editDataRow")) || null
                if (data) {
                    commit('setEditDataRow', data)
                }
            },

            getRefreshToken({commit}) {
                return axiosInstance(store.state.ServerUrl + '/auth/jwt/refresh',
                    {
                        method: "POST",

                    }
                ).then((response) => {
                    commit('SET_TOKEN_TO_VUEX', response.data.access_token)
                    axiosInstance.defaults.headers.common['Authorization'] =
                        'Bearer ' + response.data.access_token
                })
            },

            async updateUser({commit}, data) {
                try {
                    const response = await axiosInstance.patch('/users/me', data)
                    commit("user_data_set", response.data)
                } catch (error) {
                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                        reverseButtons: true
                    })
                }

            },

            async getMe({commit}) {
                try {
                    const response = await axiosInstance.get('/api/userrolestable/me')
                    commit("user_data", response.data)
                } catch (error) {
                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                        reverseButtons: true
                    })
                }

            },

            async getListUsers({commit}) {
                try {
                    const response = await axiosInstance.get('/api/userrolestable')
                    commit("users_set_data", response.data)
                } catch (error) {
                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                        reverseButtons: true
                    })
                }

            },

            async getAdminUser({commit}, id) {
                try {
                    const response = await axiosInstance.get('/api/userrolestable/user/' + id)
                    commit("users_set_edit", response.data)
                } catch (error) {
                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                        reverseButtons: true
                    })
                }

            },

            async getAdminRole({commit},) {
                try {
                    const response = await axiosInstance.get('/api/roles')
                    commit("user_set_role", response.data)
                } catch (error) {
                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                        reverseButtons: true
                    })
                }

            },

			      async getTows({commit},) {
                try {
                    const response = await axiosInstance.get('/tow')
                    commit("set_tows", response.data)
                } catch (error) {
                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                        reverseButtons: true
                    })
                }

            },

            async updateAdminUser({commit}, data) {
                data.partners = data.partners.map(item => item.value)
                try {
                    const response = await axiosInstance.patch('/users/ony/' + data.id, data)
                    commit("users_set_edit_user", response.data)
                    self.alert("Пользователь обновлен", "Success", "success", {
                        reverseButtons: true
                    })
                } catch (error) {
                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                        reverseButtons: true
                    })
                }

            },

            async delRolAdminUser({commit}, data) {
                try {
                    const response = await axiosInstance.delete('/api/userrolestable/' + data.id, {
                        params: {
                            role_id: data.role_id
                        }
                    })
                    commit("users_set_edit_user", response.data)
                } catch (error) {
                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                        reverseButtons: true
                    })
                }

            },

            // Load selectors info
            async loadSiteSelectorsInfo ({ commit }) {
              axiosInstance.get('/params/site')
                .then((res) => {
                  commit('setSiteSelectorOptions', res.data);
                })
            },

            async loadCitySelectorsInfo ({ commit }) {
              axiosInstance.get('/params/city')
                .then((res) => {
                  commit('setCitySelectorOptions', res.data);
                })
            },

            async loadPartnerSelectorsInfo ({ commit }) {
              axiosInstance.get('/params/partner_id')
                .then((res) => {
                  commit('setPartnerSelectorOptions', res.data);
                })
            },

            async loadTableSelectorsInfo ({ dispatch }) {
              dispatch('loadSiteSelectorsInfo');
              dispatch('loadCitySelectorsInfo');
              dispatch('loadPartnerSelectorsInfo');
            },

            // eslint-disable-next-line no-unused-vars
            async updateAdminUserRole({commit}, data) {
                try {
                    await axiosInstance.post('/api/userrolestable', data)
                } catch (error) {
                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                        reverseButtons: true
                    })
                }

            },

            async moderateRow ({ commit }, data) {
              axiosInstance.post('/api/sendlead', data).then((res) => {

                if (res.data.status !== 'success') {
                  self.alert(res.data.message, "Ошибка модерации", "error", {
                    reverseButtons: true
                  });
                  return;
                }

                commit('moderateRow', data);
                self.alert('Модерация прошла успешно');

              }).catch((err) => {
                self.alert(JSON.stringify(err.response.data), "Ошибка модерации", "error", {
                  reverseButtons: true
                });
              });
            }
        },

        mutations: {
            user_set_role(state, data) {
                state.userRoles = data
            },

			      set_tows(state, data){
                state.tows = data
            },

            set_can_update_table (state, data) {
              state.canUpdateTable = data;
            },

            users_set_data(state, data) {
                state.users = data
            },

            users_set_edit(state, data) {
                state.editUser = data
            },

            users_set_edit_user(state, user) {
              state.editUser.user = user
            },

            SET_TOKEN_TO_VUEX: (state, token) => {
                state.access_token = token
                localStorage.setItem('access_token', token)
            },

            SET_TABLE_TO_VUEX: ((state, payload) => {
                state.dataTable = payload
            }),

            updateTableData: ((state, payload) => {

              if (!payload || !payload.length) {
                return;
              }

              const payloadData = payload.sort((a, b) => a.Id - b.Id);

              payloadData.forEach((obj) => {
                state.dataTable.unshift(obj);
              });

            }),

            setEditDataRow: ((state, payload) => {
                state.editDataRow = payload
                // const index = state.dataTable.map(item => item.Id)
                // const index = state.dataTable.map(item => {
                //     return item
                // })
                // const item = state.dataTable.map(item => {
                //     if (item.Id === payload.Id) {
                //         return item
                //     }
                // })
                // console.log(item)
                // item.disabled = payload.disabledconst index = items.map(item => item.id).indexOf(objectId)
            }),

            editRow: ((state, payload) => {
                if (JSON.stringify(state.editDataRow) === '{}') {
                    payload.disabled = false;
                    state.editDataRow = payload;
                    state.canUpdateTable = false;
                    // localStorage.setItem('editDataRow', JSON.stringify(payload))
                } else {
                    self.alert('Закончите работы с текущей строкой')
                }
            }),

            saveRow: ((state, payload) => {
                if (JSON.stringify(state.editDataRow) !== '{}') {
                    axiosInstance(state.ServerUrl + '/orders',
                        {
                            method: "PUT",
                            data: payload,
                            headers: {'Content-Type': 'application/json'}

                        }
                    ).then((response) => {

                        if (response.data.status === 'success') {
                            state.editDataRow = {}

                            localStorage.removeItem('editDataRow')
                            self.alert('Сохранено')

                            payload.disabled = true;
                            state.canUpdateTable = true;
                        } else {
                            alert('Ошибка')
                        }

                    }).catch((error) => {
                        console.log(error);
                        self.alert(JSON.stringify(error.response.data), "Error", "error", {
                            reverseButtons: true
                        })
                    })
                } else {
                    self.alert('Нет какой-то строки для сохранения')
                }
            }),

            deleteRow: ((state, payload) => {
                self.confirm('Вы уверены что хотите удалить эту строку?', 'Удаление', 'warning', {
                    confirmButtonText: 'Да',
                    cancelButtonText: 'Нет',
                }).then(() => {
                        if (state.user === '') {
                            axiosInstance(state.ServerUrl + '/orders/', {
                                method: "DELETE",
                                params: {pk: payload.Id,},
                                headers: {'Content-Type': 'application/json'}

                            }).then((response) => {
                                    if (response.data.status === 'success') {
                                        const tableIndex = state.dataTable.indexOf(payload);
                                        if (tableIndex !== -1) {
                                            state.dataTable.splice(tableIndex, 1);
                                            self.alert('Удалено')
                                        }
                                    } else {
                                        self.alert('Неизвестная Ошибка')
                                    }

                                }
                            ).catch((error) => {
                                    console.log(error);
                                    self.alert(JSON.stringify(error.response.data), "Error", "error", {
                                        reverseButtons: true
                                    })
                                }
                            )
                        } else {
                            self.alert('У вас нет прав на удаление строки')
                        }
                    }
                ).catch(() => {
                    console.log('Удаление отменено')
                })


            }),

            viewRow: ((state, payload) => {
                const message  = payload.info.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, ' ') +  " | Источник: " + payload.source.replace(/[\\[\]]/gm, "");

                self.alert(message, "Просмотр", "info", {
                    reverseButtons: true
                })
            }),

            moderateRow (state, payload) {
              const hideIndexRow = state.dataTable.findIndex((el) => el.Id === payload.order_id);

              if (hideIndexRow !== -1) {
                state.dataTable.splice(hideIndexRow, 1);
              }
            },

            auth_request(state) {
                state.status = 'loading'
            },

            auth_success(state, access_token) {
                state.status = 'success'
                state.access_token = access_token
            },

            user_data(state, data) {
                state.userData = data
                localStorage.setItem('user_data', JSON.stringify(data))
            },

            user_data_set(state, data) {
                state.userData.user = data.user
            },

            auth_error(state) {
                state.status = 'error'
            },

            logout(state) {
                state.status = ''
                state.access_token = ''
            },

            // Selector options
            setSiteSelectorOptions(state, data) {
              state.curSelectorOptions.site = data;
            },

            setCitySelectorOptions(state, data) {
              state.curSelectorOptions.city = data;
            },

            setPartnerSelectorOptions(state, data) {
              state.curSelectorOptions.partner = data;
            },
        },

        getters: {
            DATATABLE: state => state.dataTable,
			      Tows: state => state.tows,
            editDataRow: state => state.editDataRow,
            isLoggedIn: state => !!state.access_token && !!state.userData,
            getServerUrl: state => state.ServerUrl,
            getUser: state => state.userData.user,
            getUserEmail: state => (state.userData.user)?state.userData.user.email:'',
            getUserBalance: state => (state.userData.user)?state.userData.user.deposit:'',
            getUsersList: state => state.users,
            getEditUser: state => state.editUser,
            getUserRoles: state => state.userRoles,
            meRoles: state => state.userData.roles?.map(item => item.role_name),
            isUserData: state => !state.userData,
            getUserPartners: state => state.userData.user.partners,
            canUpdateTable: state => state.canUpdateTable,

            citySelectorOptions: state => state.curSelectorOptions.city,
            siteSelectorOptions: state => state.curSelectorOptions.site,
            partnerSelectorOptions: state => state.curSelectorOptions.partner,
        }

    }
)
export default store
